var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6162 13.899L9.20288 14.371L9.69024 11.0707L18.4682 2.58576C18.8562 2.21071 19.3824 2 19.9311 2C20.4799 2 21.0061 2.21071 21.3941 2.58576C21.7821 2.96082 22.0001 3.46951 22.0001 3.99992C22.0001 4.53033 21.7821 5.03902 21.3941 5.41408L12.6162 13.899Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5517 14.0004V20.6667C18.5517 21.0203 18.4064 21.3595 18.1477 21.6095C17.8891 21.8595 17.5382 22 17.1724 22H3.37931C3.01349 22 2.66266 21.8595 2.40399 21.6095C2.14532 21.3595 2 21.0203 2 20.6667V7.33399C2 6.98038 2.14532 6.64126 2.40399 6.39122C2.66266 6.14119 3.01349 6.00072 3.37931 6.00072H10.2759",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.d5c803a29b93b02104faf5a2f42f3396.svg";
export { ForwardRef as ReactComponent };